import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';
import groupedPermissions from '../../helpers/groupedPermissions';

const getPermissions = createAsyncThunk('permissions/getPermissions',
  async (_, { rejectWithValue, }) => {
    try {
      const { data: { data: permissions } } = await authGet('/permissions');
      const permissionsObject = groupedPermissions(permissions);
      return { permissions, permissionsObject };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getPermissions;
